import { ComponentProps } from 'react'

import { cn, VStack } from '@podo-app/design-system-temp'

type Props = { heading: React.ReactNode; children: React.ReactNode } & Omit<ComponentProps<typeof VStack>, 'children'>

const PaymentSection = ({ heading, children, className, ...props }: Props) => {
  return (
    <VStack className={cn('gap-4', className)} {...props}>
      {heading}
      {children}
    </VStack>
  )
}

export default PaymentSection
